import { Box, Button, Typography } from "@mui/material"
import { ShoppingListItem } from "./ShoppingListItem"
import { IProduct } from "../types/types"
import { SetStateAction, useState } from "react"
import { ProductListDialog } from "./ProductListDialog"
import AddIcon from '@mui/icons-material/Add';
import { FloatingButton } from "react-draggable-float-btn"

export const ShoppingList = ({ products, setProducts }: { products: IProduct[], setProducts: (value: SetStateAction<IProduct[]>) => void }) => {
  const [productListOpen, setProductListOpen] = useState(false);

  const hanldeOpenProductList = () => setProductListOpen(true);
  const hanldeCloseProductList = () => setProductListOpen(false);

  const clearList = () => {
    setProducts([])
    localStorage.removeItem("localProducts");
  }

  const isEmpty = !products.length;
  const boughtProducts = products.filter((p) => p.bought);
  const localProducts = products.filter((p) => !p.productId);
  const shopProducts = products.filter((p) => p.productId);

  return (
    <>
      {isEmpty ? (
        <Box sx={{ p: 3, display: 'flex', justifyContent: 'center', alignItems: "center", flexDirection: "column", paddingTop: 16 }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-shopping-basket w-16 h-16 text-gray-300 mb-4" data-fg-baha1="5.15:5.3680:/components/ShoppingList.tsx:22:9:786:59:e:ShoppingBasket::::::C9eU"><path d="m15 11-1 9"></path><path d="m19 11-4-7"></path><path d="M2 11h20"></path><path d="m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4"></path><path d="M4.5 15.5h15"></path><path d="m5 11 4-7"></path><path d="m9 11 1 9"></path></svg>
          <Typography sx={{ marginBottom: 1 }} color="#6a7282">Lista zakupów jest pusta</Typography>
          <Typography align="center" variant="body2" color="#99a1af">Złóż zamówienie z koszyka aby wygenerować listę lub dodaj produkty ręcznie</Typography>
        </Box>
      ) : (
        <Box sx={{ p: 3 }}>
          <div>
            <ul style={{ listStyle: "none", paddingLeft: 0 }}>
              {products.filter((p) => !p.bought).length > 0  && <div style={{ margin: '8px 0px', fontWeight: "bold" }}>Do kupienia</div>}
              {shopProducts.filter((p) => !p.bought).length > 0 && <Typography sx={{ marginTop: 1, marginBottom: 1, textAlign: "center" }}>Produkty sklepowe</Typography>}
              {shopProducts.filter((p) => !p.bought).map((product) => (
                <li key={product.name}>
                  <ShoppingListItem product={product} setProducts={setProducts} />
                </li>
              ))}
              {localProducts.filter((p) => !p.bought).length > 0 && <Typography sx={{ marginTop: 1, marginBottom: 1, textAlign: "center" }}>Produkty lokalne</Typography>}
              {localProducts.filter((p) => !p.bought).map((product) => (
                <li key={product.name}>
                  <ShoppingListItem product={product} setProducts={setProducts} />
                </li>
              ))}
              {boughtProducts.length > 0 && <div style={{ margin: '8px 0px', fontWeight: "bold" }}>Kupione</div>}
              {boughtProducts.map((product) => (
                <li key={product.name}>
                  <ShoppingListItem product={product} setProducts={setProducts} />
                </li>
              ))}
            </ul>
          </div>
        </Box>
      )}
      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        <FloatingButton position={{ y: 665, x: 325 }} backgroundColor="#1f8038" color="#fff" onClick={hanldeOpenProductList}><AddIcon /></FloatingButton>
        {products.length > 0 && <Button disabled={products.length === 0} onClick={clearList} variant="text">Wyczyść listę</Button>}
      </div>
      <ProductListDialog products={products} closeProductList={hanldeCloseProductList} openProductList={hanldeOpenProductList} isOpen={productListOpen} setProducts={setProducts} />
    </>
  )
}
